import { Secret } from "../../../../schema/types/secret/entity";

export function SecretTypeTag(item: Secret): string {
  try {
    return item.type;
  } catch (e) {
    return "";
  }
}
